<template>
  <div class="matches">
    <nav class="navbar navbar-expand-lg navbar-light bg-light mb-3 border-bottom shadow-sm">
      <div class="container">
        <router-link class="navbar-brand" to="/"> <span>Playmatch</span></router-link>
        <button class="btn btn-primary" v-on:click="newMatch()" v-if="matchesLoaded && matches.length > 0">
          {{$t('general.newmatch')}}
        </button>
      </div>
    </nav>
    <div class="container">    
      <div v-if="!matchesLoaded" class="text-center">        
        <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
          <span class="sr-only">{{$t('matches.loadingmatches')}}</span>
        </div>
      </div>
      <section class="py-5 text-center container" v-if="matchesLoaded && matches && matches.length == 0">
        <div class="row py-lg-5">
          <div class="col-lg-6 col-md-8 mx-auto">
            <h1 class="font-weight-light">{{$t('matches.nomatch')}}</h1>
            
            <p class="lead text-muted">
              {{$t('matches.createfirstpart1')}}<br/> 
              {{$t('matches.createfirstpart2')}}
            </p>
            <p>
              <a class="btn btn-primary my-2" v-on:click="newMatch()">{{$t('matches.creatematch')}}</a>
            </p>
          </div>
        </div>       
      </section>
      <div v-if="matchesLoaded">
        <div v-for="match in matches" :key="match.id">
          <div class="alert match-entry" v-bind:class="{ 'alert-success': !match.hasStarted && !match.isRunning, 'alert-warning': match.isRunning, 'alert-secondary': match.hasStarted && !match.isRunning }">
            <div class="row">
              <div class="col-9 pl-1 text-truncate" v-on:click="goToMatch(match)"> 
                <a class="text-dark mr-1" v-if="match.isRunning">
                  <svg width="1.3em" height="1.3em" viewBox="0 0 16 16" class="bi bi-pause-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z"/>
                  </svg>
                </a>
                <a class="text-dark mr-1" v-else>
                  <svg width="1.3em" height="1.3em" viewBox="0 0 16 16" class="bi bi-play-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.596 8.697l-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"/>
                  </svg>
                </a>                   
                <span v-if="match.opponent">{{ match.opponent }}</span>
                <span v-else class="text-secondary">{{$t('play.noDescriptionSpecified')}}</span>
              </div>
              <div class="col-3 match-result text-right">                
                <span class="text-muted" v-if="match.hasStarted">{{match.homeCount}} - {{match.awayCount}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <nav class="navbar fixed-bottom navbar-light bg-light py-3 border-top">
      <div class="container">
        <small>
          <router-link class="text-muted nounderline" to="/about"><img src="/restack_logo.svg" alt="Restack logo" style="width: 25px" class="mr-1"/> {{$t('general.about')}}</router-link>  
        </small>
        <div class="text-right">        
          <button class="btn btn-link btn-sm text-muted nounderline" v-if="$i18n.locale != 'no'" v-on:click="setLanguage('no')">Vis på norsk</button>   
          <button class="btn btn-link btn-sm text-muted nounderline" v-if="$i18n.locale != 'en'" v-on:click="setLanguage('en')">English version</button>     
        </div>
      </div>
    </nav>
  </div>
</template>

<script lang="ts">
import { Vue } from "vue-class-component";
import moment, { lang } from "moment";
import { set, get, keys } from "idb-keyval";
import { Guid } from "guid-typescript";
import { Match } from "../models/Models";
import axios from 'axios';
import router from '../router';

export default class Matches extends Vue {
  public matches: Array<Match> = [];
  public matchesLoaded = false;

  async created() {
    const matchKeys = await keys();

    const matches: Array<Match> = [];

    for (const key of matchKeys) {
      matches.push(await get(key));
    }

    this.matches = matches.sort((a, b) => b.created.localeCompare(a.created));
    this.matchesLoaded = true;
  }

  async newMatch() {
    router.push({ name: "MatchNew" });
  }

  playMatch(match: Match) {
    router.push({ name: "PlayMatch", params: { id: match.id } });
  }

  editMatch(match: Match) {
    router.push({ name: "MatchDetails", params: { id: match.id } });
  }

  goToMatch(match: Match) {
    const hasPlayersOnField = match.players.filter(p => p.isOnField).length > 0;

    if (hasPlayersOnField || match.totalSecondsPlayed > 0 || match.isRunning || match.hasStarted) {
      this.playMatch(match);
    } else {      
      this.editMatch(match);
    }
  }

  setLanguage(language: string) {    
    localStorage.setItem('locale', language);

    this.$i18n.locale = language;
  }
}
</script>
